/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
/* External Imports */
import { CheckIcon } from '@chakra-ui/icons';
import { Box, Checkbox, Image, Link, Text, Radio, RadioGroup } from '@chakra-ui/react';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import SannidhiSectionTitle from './SannidhiSectionTitle';
/* Services */

/**
 * Renders the Sannidhi Program Detail content component
 * @param {Object} sectionContent - Data for section
 * @returns {ReactElement} Sannidhi Program content component
 */

function myFunction() {
  let stickyTitle = document.getElementById('stickyTitleSection');
  let proDet = document.getElementById('proDet');
  let stickyStart = document.getElementById('stickyContainer');
  let sticky = proDet?.offsetTop - 180;
  let stickyWrapper = document.getElementById('stickyWrapper');
  if (
    window.pageYOffset < sticky &&
    window.pageYOffset > stickyStart.offsetTop
  ) {
    stickyWrapper?.classList.add('sticky-on');
    stickyWrapper?.classList.remove('sticky-off');
    stickyTitle?.classList.add('sticky');
  } else {
    stickyWrapper?.classList.remove('sticky-on');
    stickyWrapper?.classList.add('sticky-off');
    stickyTitle?.classList.remove('sticky');
  }
}
if (typeof window !== 'undefined') {
  window.addEventListener('scroll', myFunction);
}
const ProgrmDetail = (sectionContent, region, lang, sectionId) => {
    // console.log(sectionContent);
  const moduledata = sectionContent.pageBody;
  const [enableRegister, setEnableRegister] = useState('');
  const [pageFlag, setPageFlag] = useState('');
  const [prgUrl, setPrgUrl] = useState('');
  const router = useRouter();

  return (
    <Box
      id={sectionContent.sectionId}
      bgColor="#EDE8DE"
      w="100%"
      p={{
        base: '10px 0 5px 0',
        sm: '10px 0 5px 0',
        md: '30px 0 45px 0',
      }}
      clipPath={{
        base: 'polygon(0 0, 100% 0, 100% 100%, 0 98%)',
        sm: 'polygon(0 0, 100% 0, 100% 100%, 0 98%)',
        md: 'polygon(0 0, 100% 0, 100% 100%, 0 94%)',
        lg: 'polygon(0 0, 100% 0, 100% 100%, 0 94%)',
      }}
      textAlign={'center'}
      marginBottom="30px"
      marginTop={{ base: '15px', sm: '15px', md: '50px' }}
    >
      <Box
        as="div"
        m="0 auto"
        width={{ base: '90%', sm: '90%', md: '730px', lg: '730px' }}
      >
        <SannidhiSectionTitle titleObj={moduledata[0]} />
      </Box>
      <Box width="100%">
        <Box
          as="div"
          width={{ base: '95%', sm: '95%', md: '100%', lg: '1140px' }}
          m="30px auto 0 auto"
          id="program-type"
          display={'flex'}
          flexFlow={'column'}
          alignItems={'center'}
          className="Prgrm_detail_container"
          color="#000000"
        >
          {moduledata[6]?.data?.map((el, index) => {
            return (
              <>
                <RadioGroup onChange={setPrgUrl} value={prgUrl} width={{base:'95%', md:'375px'}} minW={{base:'90%', md:'375px'}} minH={{base:'110px', md:'110px'}}>
                <Box my={2} borderRadius={'8px'} border={'1.5px solid #cccccc'}>
                    <label for={`program ${index}`}>
                      <Box display={'flex'} p="20px 15px" alignItems={'center'} justifyContent={'space-around'}>
                          <Box>
                              <Radio
                                  name="program"
                                  id={`radio${index}`}
                                  className="radio"
                                  colorScheme="orange"
                                  value={refineUrlDomain(el.RegUrl)}
                                  boxShadow="0 0 0 2.5px #D0D0D0"
                                  width="26px"
                                  height="26px"
                                  cursor="pointer"
                              />
                          </Box>
                          <Box>
                              <Text fontSize={'20px'}>{el.Category}</Text>
                              <Text fontSize={'16px'}>{el.Session}</Text>
                          </Box>
                          <Box>
                              <Text width={'140px'} height={'44px'} fontSize={'22px'} borderRadius={'40'} p="7px" bgColor={'#D9D9D980'}>{el.ProgramFee}</Text>
                          </Box>
                      </Box>
                    </label>
                    {el.StayDetail != '' && (
                        <Box width={'100%'} bgColor={'#d5cece'} p="11px 0" textAlign={'center'}><Text fontSize={'16px'}>{el.StayDetail}</Text></Box>
                    )}
                </Box>
                </RadioGroup>
              </>
            );
          })}
        </Box>
        <Box fontSize={'13px'} mt="20px"><Image
          loading="lazy" src={`${config.imgPath}/d/46272/1705660009-circle_tick_bggrey.png`}/>
            <Text as="span" pl="10px">{moduledata[7]?.text}</Text></Box>
      </Box>
      {moduledata[8]?.body != undefined && (
        <>
          <Box
            as="div"
            width={{ base: '90%', sm: '90%', md: '730px' }}
            m="35px auto 15px auto"
            fontSize="16px"
            lineHeight="27px"
            className="us_text"
          >
            {StructuredTextContent(moduledata[8]?.body)}
          </Box>
        </>
      )}
      {moduledata[9]?.body != undefined && (
        <>
          <Box
            as="div"
            width={{ base: '90%', sm: '90%', md: '730px' }}
            m="5px auto 15px auto"
            fontSize="16px"
            lineHeight="27px"
            className="us_text"
          >
            {StructuredTextContent(moduledata[9]?.body)}
          </Box>
        </>
      )}
      <Box
        as="div"
        textAlign="center"
        m="50px auto 60px auto"
        width={{ base: 'auto', sm: 'auto', md: '400px', lg: '400px' }}
        id="registernow"
      >
        {prgUrl ? (
        <NextLink
          href={refineUrlDomain(prgUrl, region, lang)}
          passHref
          legacyBehavior>
          <Link
            mt="20px"
            maxW={'auto'}
            textAlign="center"
            minH="52px"
            cursor={prgUrl ? 'pointer' : 'default'}
            bgColor={prgUrl ? '#cf4520' : '#cf452082'}
            fontWeight={500}
            disabled={prgUrl != '#' ? false : true}
            fontFamily="FedraSansStd-medium"
            fontSize={'18px'}
            padding="16px"
            borderRadius="5px"
            color="#faf7f0"
            target='_blank'
            textDecoration="none"
            _hover={{
              bg:
              prgUrl ? '#000054' : '#cf452082',
            }}
          >
            {moduledata[10]?.buttonText}
          </Link>
        </NextLink>
        ) : (
          <Link
            mt="20px"
            maxW={'auto'}
            textAlign="center"
            minH="52px"
            cursor={prgUrl ? 'pointer' : 'default'}
            bgColor={prgUrl ? '#cf4520' : '#cf452082'}
            fontWeight={500}
            disabled={prgUrl != '#' ? false : true}
            fontFamily="FedraSansStd-medium"
            fontSize={'18px'}
            padding="16px"
            borderRadius="5px"
            color="#faf7f0"
            target='_blank'
            textDecoration="none"
            _hover={{
              bg:
              prgUrl ? '#000054' : '#cf452082',
            }}
          >
            {moduledata[10]?.buttonText}
          </Link>
        )}
      </Box>
      <style>
        {`
          .chakra-radio{
              position: relative;
              cursor: pointer;
          }
          .radio{
            border:solid 1px #D0D0D0 !important;
            background:transparent !important;
            position: absolute;
            top: 0px;
            right: 0px;
            z-index: 1;
            width: 26px;
            height: 26px;
          }
          .radio:before{
            background:#CF4520 !important;
          }
          @media (max-width: 767px) {
            
          }
        `}
        </style>
    </Box>
  );
};

export default ProgrmDetail;